import { render, staticRenderFns } from "./sale_price_version.vue?vue&type=template&id=ca6910f0&"
import script from "./sale_price_version.vue?vue&type=script&lang=js&"
export * from "./sale_price_version.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports